
export const DEFAULTPAGESTORAGEKEY: string = 'defaultPage';
export const PROMPTCHATREFRESHTOKEN: string = 'promptchatRefreshToken';
